import { createIcon } from '@chakra-ui/react';

export const CopyBoldIcon = createIcon({
  displayName: 'CopyBoldIcon',
  viewBox: '0 0 16 16',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="14"
        // height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M9.04102 7.66953H7.77518C6.73685 7.66953 5.89102 6.82953 5.89102 5.78536V4.51953C5.89102 4.28036 5.69852 4.08203 5.45352 4.08203H3.60435C2.25685 4.08203 1.16602 4.95703 1.16602 6.52036V10.3937C1.16602 11.957 2.25685 12.832 3.60435 12.832H7.04018C8.38768 12.832 9.47852 11.957 9.47852 10.3937V8.10703C9.47852 7.86203 9.28018 7.66953 9.04102 7.66953Z"
          fill="#6E6789"
        />
        <path
          d="M10.3957 1.16797H9.24651H8.61068H6.95984C5.64151 1.16797 4.57401 2.00797 4.52734 3.50714C4.56234 3.50714 4.59151 3.5013 4.62651 3.5013H6.27734H6.91318H8.06234C9.40984 3.5013 10.5007 4.3763 10.5007 5.93964V7.0888V8.66963V9.8188C10.5007 9.8538 10.4948 9.88297 10.4948 9.91214C11.7957 9.8713 12.834 9.00797 12.834 7.48547V6.3363V4.75547V3.6063C12.834 2.04297 11.7432 1.16797 10.3957 1.16797Z"
          fill="#6E6789"
        />
        <path
          d="M6.98805 4.17215C6.80721 3.99132 6.49805 4.11382 6.49805 4.36465V5.89299C6.49805 6.53465 7.04055 7.05965 7.70555 7.05965C8.11971 7.06549 8.69721 7.06549 9.19305 7.06549C9.44388 7.06549 9.57221 6.77382 9.39721 6.59882C8.76138 5.96299 7.62971 4.82549 6.98805 4.17215Z"
          fill="#6E6789"
        />
      </svg>
    </>
  ),
});
